import * as React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import copy from 'clipboard-copy';

//import CopyToClipboard from './CopyToClipboard';

class CopyToClipboard extends React.Component {
  state = { showTooltip: false };

  render() {
    return (
      <Tooltip
        open={this.state.showTooltip}
        title={'Copied to clipboard!'}
        leaveDelay={1500}
        onClose={this.handleOnTooltipClose}
        {...this.props.TooltipProps || {}}
      >
        {this.props.children({ copy: this.onCopy })}
      </Tooltip>
    );
  }

  onCopy = content => {
    copy(content);
    this.setState({ showTooltip: true });
  };

  handleOnTooltipClose = () => {
    this.setState({ showTooltip: false });
  };
}

export default CopyToClipboard;



// WEBPACK FOOTER //
// ./src/components/CopyToClipboard.js